import type { FC } from "react";
import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body, Flex } from "@edreamsodigeo/prisma-design-system";

import { LightboxPopoverCircle } from "./LightboxPopoverCircle";
import type { LightBoxPopoverListProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";

export const LightboxPopoverList: FC<LightBoxPopoverListProps> = ({
  freeTrialDays,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex flexDirection={"column"} justifyContent={"flex-start"}>
        <Flex pb={"base"} alignItems={"center"}>
          <Flex>
            <LightboxPopoverCircle number={1} />
          </Flex>
          <Flex pl={"1x_small"}>
            <Body type={"small"} weight={"medium"}>
              {t("lightboxPrimeRevampDesktop.popup.one")}
            </Body>
          </Flex>
        </Flex>
        <Flex pb={"base"} alignItems={"center"}>
          <Flex>
            <LightboxPopoverCircle number={2} />
          </Flex>
          <Flex pl={"1x_small"}>
            <Body type={"small"} weight={"medium"}>
              {t("lightboxPrimeRevampDesktop.popup.two")}
            </Body>
          </Flex>
        </Flex>
        <Flex pb={"base"} alignItems={"center"}>
          <Flex>
            <LightboxPopoverCircle number={3} />
          </Flex>
          <Flex pl={"1x_small"}>
            <Body type={"small"} weight={"medium"}>
              {t("lightboxPrimeRevampDesktop.popup.three")}
            </Body>
          </Flex>
        </Flex>
        {freeTrialDays > 0 && (
          <Flex alignItems={"center"}>
            <Flex>
              <LightboxPopoverCircle number={4} />
            </Flex>
            <Flex pl={"1x_small"}>
              <Body type={"small"} weight={"medium"}>
                {t("lightboxPrimeRevampDesktop.popup.four", {
                  freeTrialDays: freeTrialDays,
                })}
              </Body>
            </Flex>
          </Flex>
        )}
      </Flex>
    </>
  );
};
